












































































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import AppModal from "@/components/global/AppModal.vue";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import BlacklistEdit from "@/views/blacklist/components/BlacklistEdit.vue";
import BlacklistModule from "@/store/modules/blacklist";
import { BlacklistPayload } from "@/models/blacklist/BlacklistPayload";
import { BlacklistState } from "@/models/store/BlacklistState";
import { BlacklistTenants } from "@/models/blacklist/BlacklistTenants";
import { blacklistHeaders } from "@/helpers/blacklist/blacklist-data-table-headers";
import { formatDate } from "@/helpers/functions/format-date";
import { formatPhone } from "@/helpers/functions/format-phone-number";
import { truncateContent } from "@/helpers/functions/truncate-content";

const blacklist = namespace(BlacklistModule.name);

@Component({
  name: "BlacklistTable",
  components: { AppModal, ApplicationLayout, BlacklistEdit, ValidationObserver, ValidationProvider }
})
export default class BlacklistTable extends Vue {
  // ===== Store ===== //
  @State("blacklist") private readonly blacklist!: BlacklistState;
  @blacklist.Action("updateBlacklistTenant") public updateBlacklistTenant!: (blacklistTenant: BlacklistPayload) => void;
  @blacklist.Action("deleteBlacklistTenant") public deleteBlacklistTenant!: (blacklistTenantId: number) => void;

  // ===== Data ===== //
  public editBlacklistModal = false;
  public deleteBlacklistModal = false;
  public loading = false;
  public selectedEditTenant: BlacklistTenants | null = null;
  public selectedDeleteTenantId = 0;
  public headers = blacklistHeaders;

  public editPayload: BlacklistPayload = {
    customer_name: "",
    email_address: null,
    phone_number: null,
    drivers_license_number: null,
    location_code: "",
    reason_alias: "",
    note: null
  };

  // ===== Methods ===== //
  public formatPhone = formatPhone;
  public formatDate = formatDate;
  public truncateContent = truncateContent;
  public handleDeleteTenantModal(tenant: BlacklistTenants) {
    this.deleteBlacklistModal = true;
    this.selectedDeleteTenantId = tenant.id;
  }
  public async handleDeleteTenant(): Promise<void> {
    this.loading = true;
    await this.deleteBlacklistTenant(this.selectedDeleteTenantId);
    this.loading = false;
    this.handleResetDeleteTenantModal();
  }
  public handleResetDeleteTenantModal(): void {
    this.selectedDeleteTenantId = 0;
    this.deleteBlacklistModal = false;
  }
  public async handleEditTenant(tenant: BlacklistTenants): Promise<void> {
    this.selectedEditTenant = tenant;
    this.editBlacklistModal = true;
  }
  public async handleEditBlacklistTenant(): Promise<void> {
    this.loading = true;
    const updatePayload = {
      id: this.selectedEditTenant!.id,
      customer_name: this.editPayload.customer_name,
      email_address: this.editPayload.email_address ? this.editPayload.email_address : null,
      phone_number: this.editPayload.phone_number ? this.editPayload.phone_number : null,
      drivers_license_number: this.editPayload.drivers_license_number
        ? this.editPayload.drivers_license_number
        : null,
      location_code: this.editPayload.location_code
        ? this.editPayload.location_code
        : this.selectedEditTenant!.location_code,
      reason_alias: this.editPayload.reason_alias
        ? this.editPayload.reason_alias
        : this.selectedEditTenant!.reason,
      note: this.editPayload.note
    };
    await this.updateBlacklistTenant(updatePayload);
    this.handleResetEditPayload();
    this.selectedEditTenant = null;
    this.editBlacklistModal = false;
    this.loading = false;
  }
  public async handleResetEditTenantModal(): Promise<void> {
    this.handleResetEditPayload();
    this.editBlacklistModal = false;
  }
  public handleResetEditPayload(): void {
    this.editPayload.customer_name = "";
    this.editPayload.email_address = null;
    this.editPayload.phone_number = null;
    this.editPayload.drivers_license_number = null;
    this.editPayload.location_code = "";
    this.editPayload.reason_alias = "";
    this.editPayload.note = null;
  };

  // ===== Computed ===== //
  get validFields(): boolean {
    return !!(this.editPayload.customer_name &&
      this.selectedEditTenant!.location_code &&
      this.selectedEditTenant!.reason &&
      this.validOptions
    );
  }
  get validOptions(): boolean {
    return !!(this.editPayload.email_address ||
      this.editPayload.phone_number ||
      this.editPayload.drivers_license_number);
  }
}
